/**
 * increase-subject-context-visibility-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Richard A Arriaga <rarriaga@safetyweb.org>
 */

import { Group } from "../../../auth/identity/group";
import { Message, ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class IncreaseSubjectContextVisibilityRequest
  extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_INCREASE_SUBJECT_CONTEXT_VISIBILITY;
	public static tag : MessageTag = MessageTag.REQ_INCREASE_SUBJECT_CONTEXT_VISIBILITY;

  public groupId : number;

  constructor (group : number | Group)
  {
    super();
    this.groupId = (group instanceof Group) ? group.id : group;
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/context-management/increase-subject-context-visibility-request.ts